import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LoginEmailEntry } from './loginEmailEntry/LoginEmailEntry';
import { LoginPasswordEntry } from './loginPasswordEntry/LoginPasswordEntry';
import { selectUserEmail, selectFirstEmailContact } from '../../slices/login.slice';
import {
    LOGIN_PATH,
    PASSWORD_PATH,
    TRUSTED_DEVICE_PATH,
    VERIFY_WITH_AUTHENTICATOR_PATH
} from '../../react-router-paths';
import { LoginTOTPVerify } from './loginOTPVerify/LoginTOTPVerify';
import { TrustedDevice } from './trustedDevice/TrustedDevice';

export function LoginContainer() {
    const otpContact = useSelector(selectFirstEmailContact);
    const userEmail = useSelector(selectUserEmail);

    return (
        <Switch>
            <Route exact path={LOGIN_PATH}>
                <LoginEmailEntry />
            </Route>
            {userEmail && (
                <Route exact path={PASSWORD_PATH}>
                    <LoginPasswordEntry />
                </Route>
            )}
            {otpContact && (
                <Route exact path={VERIFY_WITH_AUTHENTICATOR_PATH}>
                    <LoginTOTPVerify otpContact={otpContact} />
                </Route>
            )}
            {otpContact && (
                <Route exact path={TRUSTED_DEVICE_PATH}>
                    <TrustedDevice />
                </Route>
            )}
            <Redirect to={LOGIN_PATH} />
        </Switch>
    );
}
